//*** Lib */
import Cookies from 'universal-cookie';
import { decryptStorageData, encryptSotrageData } from '../../services/CryptoService';

const cookies = new Cookies();

export const createCookie = (props) => {
    let cookieValue = encryptSotrageData(props.cookieValue);
    let cookieName = props.cookieName;
    cookies.set(cookieName, cookieValue,
        {
            path: props.path,
            maxAge: props.expirationTime * 120,
            secure: true, // Ensures cookies work over HTTPS
            httpOnly: false, // Set this to true if setting cookies server-side
            sameSite: "None", // Allows cross-site cookies
            domain: ".flyingcapetech.com"
        });
};

//Store cookie
export const setCookie = (props) => {
    let cookieValue = encryptSotrageData(props.cookieValue);
    let cookieName = props.cookieName;
    cookies.set(cookieName, cookieValue);
}

export function getCookie(cookieName, doNotParse = false) {
    const cookieValue = cookies.get(cookieName, { doNotParse: doNotParse })
    if (cookieValue) {
        return decryptStorageData(cookieValue);
    }
    else {
        return null;
    }
}

export const getAllCookies = (doNotParse = false) => {
    const cookieValue = cookies.getAll({ doNotParse: doNotParse });
    return decryptStorageData(cookieValue);
};

export const removeCookie = (cookieName, options = {}) => {
    cookies.remove(cookieName, options);
};

export const removeAllCookies = () => {
    Object.keys(cookies.cookies).forEach(element => {
        cookies.remove(element, {});
    });
};

//Check cookie exist or not
export const isCookieExist = (cookieName) => !!getCookie(cookieName);
